module.exports = __webpack_public_path__ + "img/s6.e85b5c3.png";